import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tappearance: none;\n\tborder: none;\n\tcursor: pointer;\n\theight: 100%;\n\tleft: 0;\n\topacity: 0;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tpointer-events: none;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\n\tborder: 1px solid transparent;\n\tborder-radius: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tpadding: 0 4px;\n\tposition: relative;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 -2px 0 0 !important;\n\toverflow: hidden;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
import * as textInputStyles from '../TextInput/TextInput.styles';
export var UnitInputSelect = css(_templateObject());
export var UnitInputSelectUnit = css(_templateObject2(), textInputStyles.inputFontSize, ui.borderRadius.round, ui.get('controlBorderRadius'), ui.get('controlInnerControltextColor'), ui.get('controlBackgroundColorHover'));
export var disabled = css(_templateObject3());
export var UnitInputSelectElement = css(_templateObject4());
export var unitSelectFocused = css(_templateObject5(), ui.get('controlBackgroundColorHover'), ui.get('colorAdmin'));